import React from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../../lib/api';
import { formatCurrency } from '../../lib/utils';
import { Card, CardContent } from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';

export default function AdminInvestmentsPage() {
  const { data, isLoading } = useQuery({ queryKey: ['adminInvestments'], queryFn: () => api.get('/admin/investments').then(r => r.data) });
  const investments = data?.data || data || [];
  return (
    <div className="space-y-6 animate-fade-in">
      <div><h1 className="text-2xl font-bold text-white">Investments</h1><p className="text-sm text-slate-400">All platform investments</p></div>
      <Card><CardContent className="p-0"><div className="overflow-x-auto"><table className="w-full">
        <thead><tr className="border-b border-white/[0.06] bg-white/[0.02]">
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">User</th>
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">Plan</th>
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">Principal</th>
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">Earned</th>
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">Days</th>
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">Status</th>
        </tr></thead>
        <tbody className="divide-y divide-white/[0.04]">
          {isLoading ? <tr><td colSpan={6} className="px-4 py-12 text-center text-slate-500">Loading...</td></tr> :
            investments.length === 0 ? <tr><td colSpan={6} className="px-4 py-12 text-center text-slate-500">No investments</td></tr> :
            investments.map((inv: any) => (
              <tr key={inv.id} className="hover:bg-white/[0.02]">
                <td className="px-4 py-3 text-sm text-slate-300">{inv.user?.username || '-'}</td>
                <td className="px-4 py-3 text-sm text-slate-300">{inv.plan?.name || '-'}</td>
                <td className="px-4 py-3 text-sm font-medium text-white">{formatCurrency(inv.principalAmount)}</td>
                <td className="px-4 py-3 text-sm text-emerald-400">{formatCurrency(inv.totalEarned)}</td>
                <td className="px-4 py-3 text-sm text-slate-300">{inv.daysCompleted}</td>
                <td className="px-4 py-3"><Badge status={inv.status} /></td>
              </tr>
            ))}
        </tbody>
      </table></div></CardContent></Card>
    </div>
  );
}
